/**
 * @generated SignedSource<<566ad2a427b43fbe6697864d9745330b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlaceholderProjectRow_placeholder$data = {
  readonly active: boolean;
  readonly id: number;
  readonly project_memberships: ReadonlyArray<{
    readonly id: number;
    readonly workstream: {
      readonly id: number;
      readonly name: string;
    } | null | undefined;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"PlannerLeftColumn_person">;
  readonly " $fragmentType": "PlaceholderProjectRow_placeholder";
};
export type PlaceholderProjectRow_placeholder$key = {
  readonly " $data"?: PlaceholderProjectRow_placeholder$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlaceholderProjectRow_placeholder">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PlaceholderProjectRow_placeholder",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "project_members",
      "kind": "LinkedField",
      "name": "project_memberships",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "workstreams",
          "kind": "LinkedField",
          "name": "workstream",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PlannerLeftColumn_person"
    }
  ],
  "type": "people",
  "abstractKey": null
};
})();

(node as any).hash = "52088ea5777bf65587fb73155c072b41";

export default node;
